export default {"src":"https://www.bulletproof.co.uk/_next/static/media/bg-dots-circle.18a220da.svg","height":363,"width":363,"blurWidth":0,"blurHeight":0};